import React, { useEffect, useRef } from 'react';
export interface Tab {
  id: string;
  label: string;
  href?: string;
}
export interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange?: (tabId: string) => void;
  className?: string;
  'data-id'?: string;
}
export const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className = '',
  'data-id': dataId
}) => {
  const tabsRef = useRef<HTMLDivElement>(null);
  const handleTabClick = (tab: Tab) => {
    if (onTabChange) {
      onTabChange(tab.id);
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent, currentIndex: number) => {
    let newIndex = currentIndex;
    switch (e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        newIndex = currentIndex > 0 ? currentIndex - 1 : tabs.length - 1;
        break;
      case 'ArrowRight':
        e.preventDefault();
        newIndex = currentIndex < tabs.length - 1 ? currentIndex + 1 : 0;
        break;
      case 'Home':
        e.preventDefault();
        newIndex = 0;
        break;
      case 'End':
        e.preventDefault();
        newIndex = tabs.length - 1;
        break;
      default:
        return;
    }
    const tabElements = tabsRef.current?.querySelectorAll('[role="tab"]');
    if (tabElements && tabElements[newIndex]) {
      ;
      (tabElements[newIndex] as HTMLElement).focus();
      if (onTabChange) {
        onTabChange(tabs[newIndex].id);
      }
    }
  };
  return <div ref={tabsRef} role="tablist" className={`flex items-center border-b border-[#E2E8F0] overflow-x-auto ${className}`} data-id="element-3522">

      {tabs.map((tab, index) => {
      const isActive = tab.id === activeTab;
      const TabElement = tab.href ? 'a' : 'button';
      return <TabElement key={tab.id} role="tab" aria-selected={isActive} tabIndex={isActive ? 0 : -1} href={tab.href} onClick={e => {
        if (!tab.href) {
          e.preventDefault();
          handleTabClick(tab);
        }
      }} onKeyDown={e => handleKeyDown(e, index)} className={`
              relative h-[44px] px-4 text-sm font-medium
              transition-colors duration-200 ease-in-out
              flex items-center justify-center
              focus:outline-none focus:ring-2 focus:ring-[#0EA5E9] focus:ring-opacity-20
              ${isActive ? 'text-[#0EA5E9]' : 'text-[#64748B] hover:text-[#0F172A]'}
            `} style={{
        fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
      }} data-id="element-3523">

            {tab.label}
            {isActive && <span className="absolute bottom-0 left-0 right-0 bg-[#0EA5E9]" style={{
          height: '2px'
        }} aria-hidden="true" data-id="element-3524" />}
          </TabElement>;
    })}
    </div>;
};